<div class="mat-elevation-z8 mat-table-container m3-table-container">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 custom-table">
    
        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->
      
        <!-- Position Column -->
        <ng-container *ngFor="let num of [].constructor(columnNumber); let i = index" matColumnDef="{{displayedColumns[i]}}">
          <th mat-header-cell *matHeaderCellDef class="text-center"> {{labels[i]}} </th>
          <td mat-cell *matCellDef="let element"> {{element[displayedColumns[i]]}} </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
</div>
  
  